var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setAccounts } from '@popup/steem/actions/account.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import ActiveAccountUtils from '@popup/steem/utils/active-account.utils';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const AccountAuthoritiesListItem = ({ activeAccount, authority, role, navigateToWithParams, addToLoadingList, setSuccessMessage, setErrorMessage, removeFromLoadingList, goBack, }) => {
    const goTo = (accountName) => {
        window.open(`https://steempro.com/@${accountName}`);
    };
    const handleClickOnRemoveAccountAuth = (authorizedAccountName) => __awaiter(void 0, void 0, void 0, function* () {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: null,
            message: getMessage('popup_html_confirm_remove_account_authority_message', [role, authorizedAccountName]),
            fields: [
                { label: 'popup_html_username', value: `@${authorizedAccountName}` },
                {
                    label: 'popup_html_role',
                    value: getMessage(`popup_html_authority_${role}`),
                },
            ],
            title: 'popup_html_remove_account_authority',
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_remove_authorized_account_operation');
                try {
                    const updatedActiveAccountAuth = ActiveAccountUtils.removeAuthorizedAccount(activeAccount, role, authorizedAccountName);
                    let success = yield AccountUtils.updateAccount(updatedActiveAccountAuth.name, updatedActiveAccountAuth.account.active, updatedActiveAccountAuth.account.posting, updatedActiveAccountAuth.account.memo_key, updatedActiveAccountAuth.account.json_metadata, updatedActiveAccountAuth.keys.active, options);
                    if (success) {
                        goBack();
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_html_remove_account_authority_successful');
                    }
                    else {
                        setErrorMessage('popup_html_remove_account_authority_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_remove_authorized_account_operation');
                }
            }),
        });
    });
    return authority.account_auths.length > 0 ? (React.createElement("div", { className: "account-authorities-list-item" },
        React.createElement("div", { className: "top-panel" },
            React.createElement("div", { className: "key-name" },
                React.createElement("div", { className: "name" }, getMessage(`popup_html_authority_${role}`)))),
        React.createElement("div", { className: "keys-panel" },
            React.createElement("div", { className: "account-auths-list" }, authority.account_auths.map((accountAuth, index) => {
                return (React.createElement("div", { className: "item", key: `account-auth-item-${accountAuth[0]}-${index}` },
                    React.createElement("div", { className: "item-account", onClick: () => goTo(accountAuth[0]) },
                        React.createElement("img", { className: "account-img", src: `https://steemitimages.com/u/${accountAuth[0]}/avatar`, onError: (e) => {
                                e.target.onError = null;
                                e.target.src = '/assets/images/accounts.png';
                            } }),
                        React.createElement("div", { className: "account-name" }, accountAuth[0])),
                    React.createElement(SVGIcon, { className: "delete-button", icon: SVGIcons.GLOBAL_DELETE, onClick: () => handleClickOnRemoveAccountAuth(accountAuth[0]) })));
            }))))) : null;
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    setAccounts,
    navigateToWithParams,
    addToLoadingList,
    setSuccessMessage,
    setErrorMessage,
    removeFromLoadingList,
    goBack,
});
export const AccountAuthoritiesListItemComponent = connector(AccountAuthoritiesListItem);
